import React from 'react'
import { ScrollView } from 'react-native'

import { B2, Stack } from '@zet/design-system'
import { Accordian } from '@zet/design-system/accordian'

import { i18n } from '../../localization'

const Faqs = () => {
  return (
    <Stack className="h-[100%] bg-white p-3">
      <ScrollView>
        <B2 className="text-grays-80 mt-3">
          {i18n.t('brandHelpAndSupport.fAQs')}
        </B2>
        <Stack className="mt-3">
          {i18n.t('teams.faqs_content').map((item, index) => (
            <Accordian
              key={`faq-${index}}`}
              title={item.question}
              content={item.answer}
              eventName="click_action"
              eventPayload={{
                item_name: 'brands_list_help_and_support_faqs',
                question_number: index + 1,
              }}
            />
          ))}
        </Stack>
      </ScrollView>
    </Stack>
  )
}

export default Faqs
